import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ServicoTomadoListaRequest } from '../../requests/repo-dfse/servico-tomado-lista.request';
import { GetAllServicoTomadoResponse } from '../../responses/repo-dfse/get-all-servico-tomado.response';
import { LancarFinanceiroServicoTomadoRequest } from '../../requests/orquestrador-financas/lancar-financeiro-servico-tomado.request';
import { ServicoTomadoIntegracaoResponse } from '../../responses/orquestrador-financas/servico-tomado-integracao.response';
import { ExcluirFinanceiroServicoTomadoRequest } from '../../requests/orquestrador-financas/excluir-financeiro-servico-tomado.request';
import { ReturnStruct } from '../../structs/return.struct';

/**
 * Operações de Serviço Tomado que atravessam RepoDFSe (documento fiscal) e Financas (conta a
 * pagar). Ficam no orquestrador para que a permissão validada seja a da tela de Serviços
 * Tomados, e não a do módulo Financeiro.
 */
@Injectable({ providedIn: 'root' })
export class ServicoTomadoContasService extends CommonService {
  private readonly apiUrl: string = environment.urlApiOrquestradorFinancas + 'ServicoTomadoContas';

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Listagem de Serviços Tomados com a flag de financeiro lançado do próprio documento.
   */
  public getAll(request: ServicoTomadoListaRequest, paginaAtual: number = 0): Observable<GetAllServicoTomadoResponse> {
    const params = new HttpParams().set('paginaAtual', paginaAtual.toString());
    return this.httpClient
      .post<GetAllServicoTomadoResponse>(`${this.apiUrl}/getAll`, request, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  /** Lança o financeiro (1 conta a pagar com N parcelas) do Serviço Tomado. */
  public lancar(request: LancarFinanceiroServicoTomadoRequest): Observable<ServicoTomadoIntegracaoResponse> {
    return this.httpClient
      .post<ServicoTomadoIntegracaoResponse>(`${this.apiUrl}/lancar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Exclui a nota; com financeiro lançado o servidor recusa e orienta a excluir o financeiro antes. */
  public excluirServicoTomado(idNFSeEntrada: number, justificativaExclusao?: string): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/idNFSeEntrada/${idNFSeEntrada}`, {
        body: { justificativaExclusao: justificativaExclusao ?? null },
        ...this.addHeaderToken()
      })
      .pipe(catchError(this.handleError));
  }

  /** Exclui o financeiro: apaga a conta a pagar gerada pela nota (tudo ou nada, com justificativa); conta com pagamento é recusada. */
  public excluir(idNFSeEntrada: number, request: ExcluirFinanceiroServicoTomadoRequest): Observable<ServicoTomadoIntegracaoResponse> {
    return this.httpClient
      .post<ServicoTomadoIntegracaoResponse>(`${this.apiUrl}/idNFSeEntrada/${idNFSeEntrada}/excluir`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
